import {initElements} from "../../define/shared";

let anchorFound = false;

export default function initAccordion() {
    initElements(".accordion.ct-side-block", block => {
        const items = block.querySelectorAll(".accordion-item");

        items.forEach(item => {
            if (!anchorFound && item.id === window.location.hash.slice(1)) {
                item.classList.add('is--open')
                anchorFound = true;
            }
            const heading = item.querySelector(".ai-heading")

            heading.addEventListener("click", () => {
                item.classList.toggle('is--open')
                item.classList.contains('is--open') ? heading.setAttribute('aria-expanded', 'true') : heading.setAttribute('aria-expanded', 'false')
            });
        });
    });
}
